import { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router';

import './public.css';

function PublicRouteFocus() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      if (hash.length > 1) {
        const target = document.getElementById(hash.slice(1));
        target?.scrollIntoView?.({ block: 'start' });
        const focusTarget =
          hash === '#contact'
            ? document.getElementById('contact-name') ?? target
            : target;
        focusTarget?.focus({ preventScroll: true });
        return;
      }
      document.querySelector<HTMLElement>('#main-content h1')?.focus({
        preventScroll: true,
      });
    });
    return () => window.cancelAnimationFrame(animationFrame);
  }, [hash, pathname]);

  return null;
}

export function PublicShell() {
  return (
    <div className="public-shell">
      <PublicRouteFocus />
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <header className="public-header">
        <Link
          className="brand public-brand"
          to="/"
          aria-label="Flow Wizard public home"
        >
          <span className="brand__mark" aria-hidden="true">
            FW
          </span>
          <span>
            <strong>Flow Wizard</strong>
            <small>Water-transfer planning</small>
          </span>
        </Link>
        <nav aria-label="Public navigation">
          <Link to="/#how-it-works">How it works</Link>
          <Link to="/#contact">Contact</Link>
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink className="public-sign-in" to="/login">
            Sign in
          </NavLink>
        </nav>
      </header>
      <main className="public-main" id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <footer className="public-footer">
        <div>
          <Link className="public-footer__brand" to="/">
            Flow Wizard
          </Link>
          <p>Planning aid · Qualified review required</p>
        </div>
        <div className="public-footer__links">
          <nav aria-label="Public footer">
            <Link to="/#how-it-works">How it works</Link>
            <Link to="/#contact">Contact</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
